// export const data = [
//   { id: 1, title: "Therapist" },
//   { id: 2, title: "Palm reader" },
//   { id: 3, title: "Astrologer" },
//   { id: 4, title: "Tarot reader" },
//   { id: 5, title: "Psychologist" },
//   { id: 6, title: "Psychiatrist" },
//   { id: 7, title: "Relationship Counsellor" },
//   { id: 8, title: "Numerologist" },
//   { id: 9, title: "Sex Specialist" },
// ];

export const consultantCategory = [
  {
    id: 1,
    title: "Counselor",
    value: "Counselor",
  },
  {
    id: 2,
    title: "Therapist",
    value: "Therapist",
  },
  {
    id: 3,
    title: "Palm Reader",
    value: "Palm Reader",
  },
  {
    id: 4,
    title: "Astrologer",
    value: "Astrologer",
  },
  {
    id: 5,
    title: "Tarot Reader",
    value: "Tarot Reader",
  },
  {
    id: 6,
    title: "Chat Buddy",
    value: "Chat Buddy",
  },
  {
    id: 7,
    title: "Psychiatrist",
    value: "Psychiatrist",
  },

  {
    id: 8,
    title: "Numerologist",
    value: "Numerologist",
  },
  {
    id: 9,
    title: "Sex Specialist",
    value: "Sex Specialist",
  },
];
